import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiResponse, Carrier } from 'app/shared/types';
import { environment } from 'environment/environment';
import { Observable } from 'rxjs';
import { CONTROLLERS } from 'shared/services/controllers';
import { BaseApiService } from './base-api.service';

@Injectable({
  providedIn: 'root',
})
export class ScacService extends BaseApiService<
  ApiResponse<{ scacs: Carrier[] }>,
  ApiResponse<{ scac: Carrier }>,
  ApiResponse<{ id: string }>
> {
  constructor(public override http: HttpClient) {
    super(http, environment.siteManagementApiBaseUrl);
  }

  public override controllerName(): string {
    return CONTROLLERS.scacs;
  }

  public getAll(): Observable<ApiResponse<{ scacs: Carrier[] }>> {
    return this.http.get<ApiResponse<{ scacs: Carrier[] }>>(`${this.api}/${this.controllerName()}`);
  }

  public importCsv(file: File): Observable<ApiResponse<{ imported: boolean; importedAt: Date }>> {
    const formData = new FormData();
    formData.append('csvFile', file, file.name);

    return this.http.post<ApiResponse<{ imported: boolean; importedAt: Date }>>(
      `${this.api}/${this.controllerName()}/import/csv`,
      formData
    );
  }
}
